<template>
	<div id="detail">
		<img src="https://zj-web-source.oss-cn-beijing.aliyuncs.com/wxmini/imgs/mp_content_detail.jpg">
	</div>
</template>

<script>
	export default {}
</script>

<style>
	#detail {
		position: relative;
	}
	img {
		width: 100%;
		height: 100%;
	}
</style>
